import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

import { Status } from '@sh4res/bo-common/components/B2bEmployeeBulkCreate/components/bulkUploadStatus';

export function BulkUploadStatusLegend({ statuses }: { statuses: Status[] }) {
  const translate = useTranslate();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'center',
        mb: 2,
      }}>
      {statuses
        .filter((status) => status.percentage > 0)
        .map((status) => (
          <Box key={status.name} sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              sx={{
                width: 16,
                height: 16,
                backgroundColor: status.color,
                borderRadius: '2px',
                mr: 0.5,
              }}
            />
            <Typography variant="caption">
              {translate(
                `resources.bo_common.b2b.employees.actions.bulk_create.sections.results.status.${status.name}`,
              )}
            </Typography>
          </Box>
        ))}
    </Box>
  );
}
